import { AuthSignupFormControlName } from '../enums';

export const AUTH_SIGNUP_FORM_DEFAULT_VALUE = {
  [AuthSignupFormControlName.FirstName]: '',
  [AuthSignupFormControlName.LastName]: '',
  [AuthSignupFormControlName.Email]: '',
  [AuthSignupFormControlName.Password]: '',
};

export default {
  AUTH_SIGNUP_FORM_DEFAULT_VALUE,
};
